import React from "react";
import ReactDOM from "react-dom";
import { Modal } from "react-bootstrap";
import allModelsDoorsArray from "../itemSelectionView/inventory/allModelsDoorsArray";
import { useTranslation } from "react-i18next";
import "./DoorsSelectionViewModal.css";

function DoorsSelectionViewModal(props) {
  const { t } = useTranslation(["translation"]);

  if (!props.show) {
    return null;
  }

  let doorType;
  if (props.typeName) {
    doorType = props.typeName.substring(0, 20);
  }

  function findDoorName() {
    switch (doorType) {
      case "Single_Door_E":
        return "Single_Door_E";
      case "Single_Door":
        return "Single_Door_E";
      case "Single_Door_Right_Si":
        return "Single_Door_Right_SideLight";
      case "Single_Door_Left_Sid":
        return "Single_Door_Left_SideLight";
      case "Single_Door_Right_Le":
        return "Single_Door_Right_Left_SideLight";
      case "Double_Door":
        return "Double_Door_E";
      case "Double_Door_E":
        return "Double_Door_E";
      case "Double_Door_Right_Le":
        return "Double_Door_Right_Left_SideLight";
      default:
        return "Single_Door_E";
    }
  }

  function onClickEvent(doorUrl) {
    props.addItem(doorUrl, findDoorName(), null, false);
    // Close all modals in the chain
    if (props.onFinalClose) {
      props.onFinalClose();
    } else {
      props.onHide();
    }
  }

  const portalContainer = document.body;
  if (!portalContainer) return null;

  // Filter doors based on the door type
  const filteredDoors = allModelsDoorsArray.filter(
    (item) => item.url.includes(findDoorName()) && 
              !item.url.includes("8ft") && 
              !item.url.includes("6ft")
  );

  const modalContent = (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="xl"
      className="doors-selection-view-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("doorSelection-availlableDoors", "Available Doors")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="doors-selection-grid">
          {filteredDoors.length === 0 ? (
            <div className="no-doors-message">
              <p>{t("doorSelection-noDoors", "No doors available")}</p>
            </div>
          ) : (
            filteredDoors.map((item) => (
              <div
                key={item.key}
                className="door-selection-card"
                onClick={() => onClickEvent(item.url)}
              >
                <div className="door-selection-thumbnail">
                  <img src={item.url} alt={findDoorName()} />
                  <div 
                    className="door-overlay" 
                    onContextMenu={(e) => e.preventDefault()}
                  ></div>
                </div>
              </div>
            ))
          )}
        </div>
      </Modal.Body>
    </Modal>
  );

  return ReactDOM.createPortal(modalContent, portalContainer);
}

export default DoorsSelectionViewModal;
